export default {
  PAGE_TITLE: "问卷调查完成",
  ANSWER_CONTENT: "回答内容",
  THANK_YOU_ANSWER: "感谢您参与调查。",
};
